import React, { useEffect, useState } from 'react'
import useEmployeesApi from '../../api/EmployeesApi';
import PhoneNumber from "libphonenumber-js";
import { useDispatch } from 'react-redux';
import { setActionPayload, setActionType } from '../../features/authorizationSlice';
import { ACTION_TYPES } from '../../app/actionTypes';
import { useOutletContext } from 'react-router-dom';

function NewEmployees () {

    const [error, setError] = useState({});
    const [phoneNumber, setPhoneNumber] = useState("");
    const [position, setPosition] = useState("");
    const [accessLevel, setAccessLevel] = useState([])
    const {GetEmployeesRoles, employeeRole, AddEmployee} = useEmployeesApi();

    const [onOpenQrAfterGenerate]  = useOutletContext();


    const dispatch = useDispatch();

    useEffect(() => {
        GetEmployeesRoles();
    }, [])

    useEffect(() => {
        if (Array.isArray(employeeRole)) {
            setAccessLevel(employeeRole);
        }
    }, [employeeRole]);
    

    const handleSubmit = () => {
        if (validateForm()) {
            const payload = {
                mobileNo: phoneNumber,
                roleID: position
            }

            dispatch(setActionType(ACTION_TYPES.ADD_EMPLOYEE));
            dispatch(setActionPayload(payload));
            
            onOpenQrAfterGenerate()
        };
    }

    const handlePhoneChange = (event) => {
        const { value } = event.target;
    
        if (value) {
            if (/^\+?\d*$/.test(value) && value.length <= 12) {
                setPhoneNumber(value);
    
                const parsedPhoneNumber = PhoneNumber(value, "LB");
                if (parsedPhoneNumber?.isValid()) {
                    setError({ ...error, phoneNumber: "" });
                } else {
                    setError({ ...error, phoneNumber: "Phone number is invalid." });
                }
            }
        } else setPhoneNumber("");
    };
    
    const validateForm = () => {
        let isValid = true;
        const newError = {};
    
        if (!phoneNumber) {
            newError.phoneNumber = "Phone Number is required.";
            isValid = false;
        } else {
            const parserPhoneNumber = PhoneNumber(phoneNumber, "LB");
            if (!parserPhoneNumber?.isValid()) {
                newError.phoneNumber = "Phone Number format is incorrect.";
                isValid = false;
            }
        }
    
        if (!position || position === "") {
            newError.Position = "Access Level is required.";
            isValid = false;
        }
    
        setError(newError);
        return isValid;
    }

  return (

    <div className="NewEmployeeTemplate">
      <div className="title">
          ADD EMPLOYEE ACCESS
      </div>
      <div className="row phone mt-3">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row component">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">
                                Phone Number
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                <input
                                    placeholder="Xxxx"
                                    type="text"
                                    required
                                    name="phoneNumber"
                                    value={phoneNumber}
                                    onChange={handlePhoneChange}
                                    // disabled={activeButton?.employee}
                                />
                                {error.phoneNumber && (
                                        <span className="error">{error.phoneNumber}</span>
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className="row phone mt-3"></div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="row component mt-4">
                    
                        <div className="col-lg-12 subTitle">Access</div>
                        <div className="col-lg-12 desc" id="role_select">
                            <select
                                className="ddselect"
                                name="account"
                                onChange={(e) => {
                                    setPosition(e.target.value);
                                    // if (e.target.value !== "-2") {
                                    //     setCustom(false);
                                    // }
                                    setError({...error, ["position"]: ""});
                                }}
                            >
                                <option value="">Select the Access Level</option>
                                {accessLevel.map(access => (
                                    <option key={access.value} value={access.value}>
                                        {access.label}
                                    </option>
                                ))}
                            </select>
                            {error.Position && (
                                <span className="error">{error.Position}</span>
                            )}
                        </div>
                    </div>
                    </div>
                    <div className="role-based">
                        <button className="submit"
                         onClick={handleSubmit}
                         >
                            Submit
                        </button>
                    </div>
                </div>
    </div>
  )
}

export default NewEmployees;